// Write-side helper for staging odontogram JSON into the Medident Genève Firefox extension.
// Protocol: #odontogram-data + window.postMessage (CustomEvent kept as fallback).

const DEFAULT_TIMEOUT_MS = 4000;
const REQUEST_TYPE = 'odontogram-filler:extract-request';
const RESULT_TYPE = 'odontogram-filler:extract-result';
const STAGE_HELPER_VERSION = 'page-stage-v3';

export function stageOdontogramData(data, { timeoutMs = DEFAULT_TIMEOUT_MS } = {}) {
  const pageUrl = document.URL;
  const bridgeAttr = document.documentElement.getAttribute('data-odontogram-filler');
  console.log(`[${STAGE_HELPER_VERSION}] start`, {
    href: pageUrl,
    bridgeAttr,
    teethEtat: data?.etat_denture?.length ?? 0,
    teethTraitement: data?.traitement_envisage?.length ?? 0,
  });

  if (!bridgeAttr) {
    console.warn(
      `[${STAGE_HELPER_VERSION}] content script NOT detected (no data-odontogram-filler on <html>). ` +
        'Reload the temporary add-on in about:debugging, then hard-refresh this tab.'
    );
  }

  let el = document.getElementById('odontogram-data');
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/json';
    el.id = 'odontogram-data';
    document.body.appendChild(el);
    console.log(`[${STAGE_HELPER_VERSION}] created #odontogram-data`);
  }
  el.textContent = JSON.stringify(data);

  return new Promise((resolve) => {
    let settled = false;

    function finish(result, via) {
      if (settled) return;
      settled = true;
      window.removeEventListener('message', onMessage);
      window.removeEventListener(RESULT_TYPE, onCustomEvent);
      clearTimeout(timer);
      console.log(`[${STAGE_HELPER_VERSION}] finish via=${via}`, result);
      resolve(result);
    }

    function parseDetail(detail) {
      try {
        return typeof detail === 'string' ? JSON.parse(detail) : detail;
      } catch (e) {
        console.error(`[${STAGE_HELPER_VERSION}] bad detail`, detail, e);
        return { ok: false, error: 'Réponse illisible de l’extension.' };
      }
    }

    function onMessage(event) {
      if (!event.data || event.data.type !== RESULT_TYPE) return;
      console.log(`[${STAGE_HELPER_VERSION}] got postMessage result`, event.data);
      finish(parseDetail(event.data.detail), 'postMessage');
    }

    function onCustomEvent(event) {
      console.log(`[${STAGE_HELPER_VERSION}] got CustomEvent result`, event.detail);
      finish(parseDetail(event.detail), 'CustomEvent');
    }

    const timer = setTimeout(() => {
      const stillMissing = !document.documentElement.getAttribute('data-odontogram-filler');
      console.error(`[${STAGE_HELPER_VERSION}] TIMEOUT after ${timeoutMs}ms`, {
        bridgeStillMissing: stillMissing,
        href: pageUrl,
      });
      finish({
        ok: false,
        error: stillMissing
          ? `[${STAGE_HELPER_VERSION}] Content script absent sur cette page. about:debugging → Reload l’extension, puis Cmd+Shift+R ici. URL: ${pageUrl}`
          : `[${STAGE_HELPER_VERSION}] Content script présent mais silencieux — voir la console de l’extension (Inspect).`,
      }, 'timeout');
    }, timeoutMs);

    window.addEventListener('message', onMessage);
    window.addEventListener(RESULT_TYPE, onCustomEvent);
    console.log(`[${STAGE_HELPER_VERSION}] dispatching request (postMessage + CustomEvent)`);
    window.postMessage({ type: REQUEST_TYPE, debug: STAGE_HELPER_VERSION }, '*');
    window.dispatchEvent(new CustomEvent(REQUEST_TYPE));
  });
}
